import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { userSettingsTranslationRef } from '@backstage/plugin-user-settings/alpha';

export const userSettingsTranslation = TranslationBlueprint.make({
  name: 'user-settings',
  params: {
    resource: createTranslationMessages({
      ref: userSettingsTranslationRef,
      full: false,
      messages: {
        'languageToggle.title': 'Taal',
        'languageToggle.description': 'Wijzig de taal',
        'languageToggle.select': 'Kies taal {{language}}',
        'themeToggle.title': 'Thema',
        'themeToggle.description': 'Wijzig de themamodus',
        'themeToggle.select': 'Kies {{theme}}',
        'themeToggle.selectAuto': 'Kies automatisch thema',
        'themeToggle.names.light': 'Licht',
        'themeToggle.names.dark': 'Donker',
        'themeToggle.names.auto': 'Automatisch',
        'signOutMenu.title': 'Uitloggen',
        'signOutMenu.moreIconTitle': 'meer',
        'pinToggle.title': 'Zet zijbalk vast',
        'pinToggle.description': 'Voorkom dat de zijbalk inklapt',
        'pinToggle.switchTitles.unpin': 'Maak zijbalk los',
        'pinToggle.switchTitles.pin': 'Zet zijbalk vast',
        'pinToggle.ariaLabelTitle': 'Schakelaar zijbalk vastzetten',
        'identityCard.title': 'Identiteit in het portaal',
        'identityCard.noIdentityTitle': 'Geen identiteit in het portaal',
        'identityCard.userEntity': 'Gebruikersentiteit',
        'identityCard.ownershipEntities': 'Entiteiten voor eigenaarschap',
        'defaultProviderSettings.description':
          "Regelt de authenticatie voor API's en identiteiten van {{provider}}",
        'emptyProviders.title': 'Geen authenticatieproviders',
        'emptyProviders.description':
          'Je kunt authenticatieproviders aan het portaal toevoegen, zodat je via die providers kunt inloggen.',
        'emptyProviders.action.title':
          'Open app-config.yaml en breng de gemarkeerde wijzigingen aan:',
        'emptyProviders.action.readMoreButtonTitle': 'Meer informatie',
        'providerSettingsItem.title.signIn': 'Inloggen bij {{title}}',
        'providerSettingsItem.title.signOut': 'Uitloggen bij {{title}}',
        'providerSettingsItem.buttonTitle.signIn': 'Inloggen',
        'providerSettingsItem.buttonTitle.signOut': 'Uitloggen',
        'authProviders.title': 'Beschikbare providers',
        'defaultSettingsPage.tabsTitle.general': 'Algemeen',
        'defaultSettingsPage.tabsTitle.authProviders': 'Authenticatieproviders',
        'defaultSettingsPage.tabsTitle.featureFlags': 'Feature flags',
        'featureFlags.title': 'Feature flags',
        'featureFlags.description':
          'Ververs de pagina nadat je feature flags hebt gewijzigd',
        'featureFlags.emptyFlags.title': 'Geen feature flags',
        'featureFlags.emptyFlags.description':
          'Met feature flags kunnen plugins functies registreren die gebruikers zelf kunnen inschakelen. Zo kun je bijvoorbeeld handmatig A/B-testen.',
        'featureFlags.emptyFlags.action.title':
          'Hieronder staat gemarkeerd hoe je een feature flag toevoegt:',
        'featureFlags.emptyFlags.action.readMoreButtonTitle': 'Meer informatie',
        'featureFlags.filterTitle': 'Filter',
        'featureFlags.clearFilter': 'Wis filter',
        'featureFlags.flagItem.title.disable': 'Schakel uit',
        'featureFlags.flagItem.title.enable': 'Schakel in',
        'featureFlags.flagItem.subtitle.registeredInApplication':
          'Geregistreerd in de applicatie',
        'featureFlags.flagItem.subtitle.registeredInPlugin':
          'Geregistreerd in plugin {{pluginId}}',
        'settingsLayout.title': 'Instellingen',
        sidebarTitle: 'Instellingen',
        'profileCard.title': 'Profiel',
        'appearanceCard.title': 'Weergave',
      },
    }),
  },
});
